const drivers = {
  table: {
    filters: {
      suppliers: 'Flotten',
    },
  },

  forms: {
    information: {
      supplier: {
        header: 'Flotten',
        fields: {
          suppliers: 'Flotten',
        },
      },
    },
  },
};

export default drivers;
